module.exports = __webpack_public_path__ + "img/1.783de630.jpg";